import request from "../request";

/**
 * Поиск
 * @return {Promise}
 */
export const search = data => {
	return request({
		url: "/search",
		type: "GET",
		data: data,
	});
};

/**
 * Поиск новый
 * @return {Promise}
 */
export const searchNew = data => {
	return request({
		url: "/search/new",
		type: "GET",
		data: data,
	});
};
